export const GET_ORDER = 'get-order';
export const GET_SITE_CONFIG = 'get-site-config';
